export default "./dist/stdassets/cursors/zoomin.cur";